import React from "react";

export const REGISTRATIONS_HELP_TITLE = "Cadastros";

export function RegistrationsHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> O menu <strong>Cadastros</strong> é
        onde você prepara a fazenda para usar a plataforma e o app de campo.
        Sem esses cadastros, os dados do campo não se organizam direito.
      </p>

      <p>
        <strong>O que cadastrar aqui:</strong>
      </p>
      <ul>
        <li>
          <strong>Máquinas</strong> — tratores, colheitadeiras e demais
          equipamentos. É também onde se define checklist ao assumir, foto
          do painel, hectares e alertas daquela máquina.
        </li>
        <li>
          <strong>Bombas de combustível</strong> — pontos de abastecimento
          da fazenda, para organizar os lançamentos de diesel.
        </li>
        <li>
          <strong>Operadores</strong> — quem usa o app no campo. Pedidos de
          acesso novos aparecem com o aviso laranja neste menu.
        </li>
        <li>
          <strong>Sub-fazendas</strong> — divisões ou unidades da
          propriedade, quando a fazenda trabalha em mais de um sítio.
        </li>
        <li>
          <strong>Cadastro de Administradores</strong> — gestores com acesso
          à plataforma web.
        </li>
      </ul>

      <p>
        <strong>Por que fazer primeiro?</strong> Máquinas e operadores
        precisam existir aqui para telemetria, turnos, abastecimentos e
        alertas aparecerem certos. Sem esse cadastro, o que o app enviar
        não se aproveita bem na plataforma.
      </p>

      <p>
        <strong>Ordem sugerida:</strong> cadastre operadores e máquinas,
        depois bombas, sub-fazendas e administradores. O aviso laranja em
        Operadores indica pedido de acesso do app ainda sem resposta.
      </p>
    </>
  );
}
